import { render, staticRenderFns } from "./UngroupNeed.vue?vue&type=template&id=fff1f7d2&"
import script from "./UngroupNeed.vue?vue&type=script&lang=js&"
export * from "./UngroupNeed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "UngroupNeed.vue"
export default component.exports